import { v4 as uuidv4 } from 'uuid';
import { StorageManager } from '@funtech-int/web-toolkit';

const DEVICE_UUID = 'deviceUuid';

export function getDeviceUuid(storage: StorageManager): string {
    let deviceUuid = storage.local.get<string>(DEVICE_UUID);
    if (!deviceUuid) {
        deviceUuid = uuidv4();
        storage.local.set(DEVICE_UUID, deviceUuid);
    }
    return deviceUuid;
}
